import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiStatsV2ReservationDailyElFindHospitalParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiStatsV2ReservationDailyElFindHospitalParams, unknown>

const fetchStatsReservationDailyHospital = async (params: ApiStatsV2ReservationDailyElFindHospitalParams) => {
  const { data } = await apiClient.v2.apiStatsV2ReservationDailyElFindHospital(params);
  return checkApiResponse(data);
}

export const statsReservationDailyHospitalKeys = {
  all: [QUERY_KEY.v2apiStatsV2ReservationDailyElFindHospital] as const,
  list: (params: ApiStatsV2ReservationDailyElFindHospitalParams) => [...statsReservationDailyHospitalKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(statsV2ReservationDailyFindHospitalQueryOptions(params))` */
export const statsV2ReservationDailyFindHospitalQueryOptions = (params: ApiStatsV2ReservationDailyElFindHospitalParams) => ({
  queryKey: statsReservationDailyHospitalKeys.list(params),
  queryFn: () => fetchStatsReservationDailyHospital(params),
})

export const useStatsV2ReservationDailyFindHospitalQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: statsReservationDailyHospitalKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchStatsReservationDailyHospital(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
